type HeaderRole = "admin" | "buyer" | "seller" | "both";

type MeUser = {
  role?: string;
  profileImage?: string;
  avatar?: string;
};

function resolveHeaderRole(headerRole: HeaderRole, user: MeUser): "admin" | "buyer" | "seller" {
  const roleFromApi = String(user.role ?? "").toLowerCase();
  if (roleFromApi === "super_admin" || roleFromApi === "company_admin") {
    return "admin";
  }
  if (roleFromApi === "seller" || roleFromApi === "buyer_seller") {
    return "seller";
  }
  if (headerRole === "seller") return "seller";
  return "buyer";
}

export async function resolveHeaderAvatarUrl(
  headerRole: HeaderRole,
  user: MeUser | null | undefined,
  previewUrl?: string,
): Promise<string | null> {
  if (!user) return null;
  const normalizedRole = resolveHeaderRole(headerRole, user);
  if (normalizedRole === "admin") return null;
  const trimmedPreview = typeof previewUrl === "string" ? previewUrl.trim() : "";
  if (trimmedPreview.length > 0) return trimmedPreview;
  const fromMe = user.profileImage?.trim() || user.avatar?.trim() || "";
  if (fromMe) return fromMe;

  try {
    const { profileService } = await import("@b2b/services");
    const response = await profileService.getProfile();
    const raw = response as unknown as Record<string, unknown>;
    const profile =
      raw?.success === true && raw?.data
        ? (raw.data as Record<string, unknown>)
        : raw;
    const company = (profile?.company ?? {}) as Record<string, unknown>;
    const sellerLogo =
      String(company.logo ?? profile?.companyLogo ?? profile?.logo ?? "").trim();
    const buyerImage = String(profile?.profileImage ?? "").trim();
    const url = normalizedRole === "seller" ? sellerLogo : buyerImage;
    return url || null;
  } catch {
    return null;
  }
}
